import { render } from "./PageNotFound.vue?vue&type=template&id=04a94000"
import script from "./PageNotFound.vue?vue&type=script&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&lang=ts"
script.render = render

export default script